import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './contratoServicoActions';

class ContratoServicoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>

						<Row>
							
							<Field
								maxWidth={180}
								name='valor_unitario'
								component={LabelAndInputNumber}
								label='Valor Unitário' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='valor_mensal'
								component={LabelAndInputNumber}
								label='Valor Mensal' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='percentual_imposto'
								component={LabelAndInputNumber}
								label='Percentual de Imposto' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
								
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Remover'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

ContratoServicoForm = reduxForm({form: 'contratoServicoForm', destroyOnUnmount: false})(ContratoServicoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('contratoServicoForm')(state),
	registro: state.contratoServico.registro,
	listaConvenio: state.hospitalConvenio.listaSelect,
	listaExame: state.exame.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoServicoForm);
